import Css from "./style.module.scss";

import quickBooksPreview from "assets/bookeAiStatusQuickBooks.png";
import xeroPreview from "assets/bookeAiStatusXero.png";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Button from "nlib/ui/Button";
import Environment from "utils/Environment";
import IntegrationServices from "const/IntegrationServices";
import Modal from "nlib/ui/Modal";
import React, { Fragment, useCallback } from "react";
import Texts from "utils/Texts";

const ODD = 2;

const BrowserExtensionModal = ({ integrationService, onClose }) => {
  const { uiTexts, messages, errors } = useSelector(getTextsData);

  const { CHROME_BROWSER_EXTENSION_URL } = Environment.getProcessEnvVars();

  const { label: serviceName } = IntegrationServices.getByValue(integrationService);

  const extensionModalDescription = Texts.replaceVars(messages.extensionModalDescription, { serviceName });

  const handleDownload = useCallback(() => {
    window.open(CHROME_BROWSER_EXTENSION_URL, "_blank", "noopener,noreferrer");
  }, [CHROME_BROWSER_EXTENSION_URL]);

  const handleCopyLink = useCallback(async() => {
    const { clipboard } = window.navigator;

    if (!clipboard || !clipboard.writeText) {
      toast.error(errors.unknown);

      return;
    }
    try {
      await clipboard.writeText(CHROME_BROWSER_EXTENSION_URL);
      toast.info(uiTexts.copiedToClipboard);
    } catch (error) {
      toast.error(errors.unknown);
    }
  }, [CHROME_BROWSER_EXTENSION_URL, errors.unknown, uiTexts.copiedToClipboard]);

  return (
    <Modal
      className={Css.extensionModal}
      dialogClassName={Css.dialog}
      headerClassName={Css.header}
      contentClassName={Css.content}
      iconComponent={null}
      title={null}
      onClose={onClose}>
      <div className={Css.hero}>
        <h2 className={Css.title}>{messages.extensionModalTitle}</h2>
        <div className={Css.description}>
          {extensionModalDescription.split("*").map((text, index) => {
            return (
              <Fragment key={String(index + 1)}>
                {index % ODD ? <b>{text}</b> : text}
              </Fragment>
            );
          })}
        </div>
      </div>
      <div className={Css.preview}>
        <img
          width="1000"
          height="480"
          src={integrationService === IntegrationServices.XERO.value ? xeroPreview : quickBooksPreview}
          alt="" />
      </div>
      <div className={Css.actions}>
        <Button large outline icon={Icons.LinkSimple} onClick={handleCopyLink}>
          {uiTexts.copyLinkForColleagues}
        </Button>
        <Button large primary icon={Icons.DownloadSimple} onClick={handleDownload}>
          {uiTexts.downloadExtension}
        </Button>
      </div>
    </Modal>
  );
};

export default React.memo(BrowserExtensionModal);
